/*******************************************************************************
* Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
*                 This work contains trade secrets and confidential materials
*                 of Honeywell Inc., and its use or disclosure in whole or in
*                 part without express written permission of Honeywell Inc.
*                 is prohibited.
*
* Name          : NonMSACustomerKeys.tsx
*
* Project Title : Checkout
*
* Description   : Initial version
*
* Company       : Honeywell Technology Solutions , Hyderabad
*
* @Author       : H422336
*
* @Date         : Sep 14, 2020
*
* @Version      : Version 1.0
*
* By             : H422335
* On             : Sep 15,2020
* Description    : ASDS-3039 UI enhancements as part of ASDS phase 2
*
*
* By             : H422336
* On             : Oct 06,2020
* Description    : ASDS-3227 APU enhancements as part of phase-2
*
* By             : H422337
* On             : Oct 14,2020
* Description    : ASDS-3566 APU enhancements as part of phase-2
*
* By            : H422337
* On            : Nov 18, 2020
* Description   : ASDS - 4073 - selection checkbox bug fixes - Phase-2
 *
******************************************************************************/
import * as React from 'react';
import '@scuf/common/honeywell/theme.css';
import { connect } from 'react-redux';
import './ConfigureAPU.css';
import { DataTable } from '@scuf/datatable';
import { ICellData } from '@scuf/datatable/dist/components/DataTable/IDataTableInterfaces';
import { Icon, Notification, Input, Select } from '@scuf/common';
import Item from '@scuf/datatable/dist/components/DataTable/ActionBar/Item/Item';
import CheckoutConstants, { ApuErrorLabels } from '../constants/checkout-constants';
import ConfigureAPUActions from '../redux/actions/configure-apu-actions';
import ApuOrderApiActions from '../redux/actions/apu-order-api-actions';

interface INonMSAKeyOnly {
    productId: string;

    productData: any;
    showAPUValidationErrorMsg: boolean;

    deleteRow: Function;
    addNewRow: Function;
    updateNonMsaKeyOnlySerialNumber: Function;
    hideAPUValidationErrMsg: Function;
    getSubProductDetails: Function;
    featuresMasterData: any,
    updateNonMsaKeyOnlySubscription:Function;
}

class NonMSACustomerKeys extends React.Component<INonMSAKeyOnly, any> {
    constructor(props) {
        super(props);
        this.state = {
            selectedRowData: [],
            errorRowData: [],
        };
        this.rowExpansionTemplate = this.rowExpansionTemplate.bind(this);
    }

    updateSerialNumber(newVal: any, cellData: ICellData): void {
        
        this.updateSelectedRowData(cellData);
        this.props.hideAPUValidationErrMsg(true);
        if (cellData.field === 'serialNumber') {
            this.props.updateNonMsaKeyOnlySerialNumber(newVal, cellData.rowIndex);
        }
        this.props.hideAPUValidationErrMsg(true);
    }

    deleteMultipleItems() {
        this.props.deleteRow(this.state.selectedRowData);
        this.setState({ selectedRowData: [] });
    }

    addAPUMultipleRow(): void {
        this.props.addNewRow(0);
        this.props.hideAPUValidationErrMsg(true);
        // this.props.hideAPUValidationErrMsg(false);

    }

    unitPriceRenderer(cellData: ICellData) {
        return <span>{`$${cellData.value.toFixed(2)}`}</span>;
    }


    rowExpansionTemplate(data: any) {
        
        let errorMsg: string = '';
        let errorTitle: string = '';

        if (data.serialNumberError !== '') {
            errorMsg = data.serialNumberError;
            if (errorMsg === ApuErrorLabels.MSA_SERIAL_ERROR_EMPTY) {
                errorTitle = ApuErrorLabels.ALL_FIELDS_EMPTY_ERROR;
            } else if (errorMsg === ApuErrorLabels.MSA_SERIAL_ERROR_INVALID) {
                errorTitle = ApuErrorLabels.SERIAL_NUMBER_INVALID;
            } else {
                errorTitle = ApuErrorLabels.SERIAL_NUMBER_DUBLICATE;
            }
        }
        if(data.optionError !== '') {
            errorMsg = data.optionError;
            if (errorMsg === ApuErrorLabels.NON_MSA_KEY_ONLY_PERIOD) {
                errorTitle = ApuErrorLabels.ALL_FIELDS_EMPTY_ERROR;
            }
        }
        if (this.props.showAPUValidationErrorMsg) {
            if (errorTitle === ApuErrorLabels.ALL_FIELDS_EMPTY_ERROR ) {
                return  <Notification hasIcon={true} severity="important"  title={errorTitle} style={{margin: 0}} onCloseClick={() => {this.props.hideAPUValidationErrMsg(false); }} >{errorMsg}</Notification>;
            } else {
                return  <Notification hasIcon={true} severity="critical"  title={errorTitle} style={{margin: 0}} onCloseClick={() => {this.props.hideAPUValidationErrMsg(false); }}  >{errorMsg}</Notification>;
            }
        } else {
           return;
        }
    }

    updateSelectedRowData(cellData: ICellData) {
        if (this.state.selectedRowData.length !== 0) {
            const indexFromSelectedRowData = this.state.selectedRowData.findIndex((x: any) => x.serialNumber === cellData.rowData.serialNumber);
            if (indexFromSelectedRowData !== -1) {
                    let  selecedData = [...this.state.selectedRowData];
                    selecedData.splice(indexFromSelectedRowData, 1);
                    this.setState({selectedRowData: selecedData});
            }
        }
        
  }

  componentDidMount() {
    const {getApuOrderData}: any = this.props;
    getApuOrderData(this.props.productId);
  }

    render() {
        let ErrorRowData = this.props.productData.filter((product: any) => {
            if ( typeof product.validInputData !== 'undefined' && !product.validInputData && (product.serialNumberError !== '' || product.optionError !== '')) {
                return product;
            }
        });
        
        return (
            <div>
                <p className="data-table-heading">Add Details for Key Only</p>
                <DataTable
                    data={this.props.productData}
                    onEdit={(newVal: any, cellData: ICellData) => this.updateSerialNumber(newVal, cellData)}
                    selectionMode="multiple"
                    selection={this.state.selectedRowData}
                    onSelectionChange={(e) => this.setState({ selectedRowData: e })}
                    expandedRows={ErrorRowData}
                    rowExpansionTemplate={this.rowExpansionTemplate}
                >
                    <DataTable.HeaderBar>
                        <DataTable.HeaderBar.Item
                            content="Add"
                            iconSize="small"
                            icon="slidercontrols-plus"
                            onClick={() => this.addAPUMultipleRow()}
                        />
                    </DataTable.HeaderBar>
                    <DataTable.ActionBar>
                        <Item
                            icon={<Icon name="delete" root="common" size="small" />}
                            content="Delete"
                            onClick={() => this.deleteMultipleItems()}
                        />
                    </DataTable.ActionBar>
                    <DataTable.Column field="serialNumber" header="APU Serial Number" align="left" renderer={(cellData) => this.serialNumberRenderer(cellData)}/>
                    <DataTable.Column field="optionId" header="Subscription Period" align="left" renderer={(cellData) => this.subscriptionPeriodRenderer(cellData)}/>
                    <DataTable.Column field="unitPrice" header="Unit Price"  align="left" editable={false} renderer={this.unitPriceRenderer}/>
                </DataTable>
            </div>
        );
    }


    subscriptionPeriodRenderer(cellData: ICellData) {
        const keyOnlyNonMSASubProduct = this.props.featuresMasterData?.filter(feature  => feature.subProductDesc === CheckoutConstants.NON_MSA_KEY_ONLY_ORDER);

        const subscriptionPeriodOptions =keyOnlyNonMSASubProduct &&  keyOnlyNonMSASubProduct[0]?.options?.map (periods => {
             return {value: periods?.optionId, text: periods?.optionName }
        })
        return (
          <React.Fragment>
          <Select
                    key={cellData.rowIndex}
                    className="contract-number-dropdown"
                    fluid={true}
                    placeholder="Choose subscription period"
                    value={cellData.rowData.optionId}
                    search={true}
                    options={subscriptionPeriodOptions}
                     onChange={(value: any) => { this.props.updateNonMsaKeyOnlySubscription(value, cellData.rowIndex); }}
          />
          </React.Fragment>
        );
      }
     serialNumberRenderer(cellData: ICellData) {
        return (
            <Input placeholder="Enter serial number" disabled={false} type="string" className="datatable-text-input" fluid={true} value={cellData.rowData.serialNumber} onChange={(newVal: string) => this.updateSerialNumber(newVal, cellData)} />
        );
    }
}

const mapDispatchToProps = {
    addNewRow: ConfigureAPUActions.addApuNonMSAKeyOnlyRow,
    deleteRow: ConfigureAPUActions.deleteApuNonMsaKeyOnlyRow,
    updateNonMsaKeyOnlySerialNumber: ConfigureAPUActions.updateApuNonMsaKeyOnlySerialNumber,
    hideAPUValidationErrMsg : ConfigureAPUActions.hideAPUValidationErrorMsg,
    getSubProductDetails: ConfigureAPUActions.getSubProductDetails,
    updateNonMsaKeyOnlySubscription: ConfigureAPUActions.updateApuNonMsaKeyOnlySubscriptionPeriod,
    getApuOrderData: ApuOrderApiActions.getApuOrderData
};

function mapStateToProps(state: any) {

    return {
        productData: state.configAPUData.payload.nonMsaKeyOnlyOrderConfigData,
        featuresMasterData: state.configAPUData.payload.featuresMasterData,
        isProductFetching: state.configAPUData.payload.isProductFetching,
        isProductFetchSuccess: state.configAPUData.payload.isProductFetchSuccess,
        showAPUValidationErrorMsg: state.configAPUData.payload.showAPUValidationErrorMsg,
        orderData: state.apuOrderDetails?.apuOrderDetails
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(NonMSACustomerKeys);
